"use client";

import { useAnalytics } from "@/hooks/use-analytics";
import { usePathname, useSearchParams } from "next/navigation";
import { Suspense, useEffect } from "react";

function AnalyticsPageViewInner() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const analytics = useAnalytics();

  useEffect(() => {
    if (!pathname) {
      return;
    }

    const url = new URL(pathname, window.location.origin);
    url.search = searchParams.toString();

    analytics.trackPageView(url.toString());
  }, [pathname, searchParams, analytics]);

  return null;
}

AnalyticsPageViewInner.displayName = "AnalyticsPageViewInner";

export function AnalyticsPageView() {
  return (
    <Suspense fallback={null}>
      <AnalyticsPageViewInner />
    </Suspense>
  );
}

AnalyticsPageView.displayName = "AnalyticsPageView";
